module.exports = __webpack_public_path__ + "static/media/Favorites_Icon_Inactive@3x.38af9ed0.png";